(() => {
const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (root, selector) => Array.from(root.querySelectorAll(selector));
const money = (cents) => {
const currency = window.APEXRIDE?.currency || 'USD';
try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
catch (_) { return `${(Number(cents) / 100).toFixed(2)} ${currency}`; }
};
const toast = (message) => {
const el = $('[data-nv-toast]');
if (!el) return;
el.textContent = message;
el.classList.add('is-visible');
window.clearTimeout(el._hideTimer);
el._hideTimer = window.setTimeout(() => el.classList.remove('is-visible'), 3200);
};
const menu = $('[data-mobile-menu]');
const menuOpen = $('[data-menu-open]');
const menuClose = $('[data-menu-close]');
const closeMenu = () => {
if (!menu || !menuOpen) return;
menu.hidden = true;
menuOpen.setAttribute('aria-expanded', 'false');
};
if (menu && menuOpen) {
menuOpen.addEventListener('click', () => {
menu.hidden = !menu.hidden;
menuOpen.setAttribute('aria-expanded', String(!menu.hidden));
});
menuClose?.addEventListener('click', closeMenu);
menu.addEventListener('click', (event) => { if (event.target.closest('a')) closeMenu(); });
}
const drawer = $('[data-cart-drawer]');
const backdrop = $('[data-cart-backdrop]');
const closeCartButton = $('[data-cart-close]');
const drawerBody = $('[data-cart-drawer-body]');
const openCart = () => {
if (!drawer || !backdrop) return;
drawer.classList.add('is-open');
drawer.setAttribute('aria-hidden', 'false');
backdrop.hidden = false;
document.body.classList.add('nv-lock');
closeMenu();
};
const closeCart = () => {
drawer?.classList.remove('is-open');
drawer?.setAttribute('aria-hidden', 'true');
if (backdrop) backdrop.hidden = true;
document.body.classList.remove('nv-lock');
};
closeCartButton?.addEventListener('click', closeCart);
backdrop?.addEventListener('click', closeCart);
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { closeCart(); closeMenu(); } });
const updateCartUi = (cart) => {
$$ (document, '[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
$$ (document, '[data-cart-link]').forEach((node) => node.setAttribute('aria-label', `Cart, ${cart.item_count} items`));
const drawerCount = $('[data-drawer-count]');
if (drawerCount) drawerCount.textContent = cart.item_count;
const subtotal = $('[data-drawer-subtotal]');
if (subtotal) subtotal.textContent = money(cart.total_price);
if (!drawerBody) return;
drawerBody.replaceChildren();
if (!cart.items.length) {
const empty = document.createElement('p');
empty.className = 'nv-empty-cart';
empty.textContent = 'Your cart is currently empty.';
drawerBody.append(empty);
return;
}
cart.items.forEach((item) => {
const line = document.createElement('div');
line.className = 'nv-drawer-line';
const imageWrap = document.createElement('div');
imageWrap.className = 'nv-drawer-line__image';
if (item.image) {
const img = document.createElement('img');
img.src = item.image;
img.alt = item.product_title || '';
img.loading = 'lazy';
imageWrap.append(img);
}
const copy = document.createElement('div');
const title = document.createElement('strong');
title.textContent = item.product_title || item.title || 'Product';
const variant = document.createElement('p');
variant.textContent = `${item.variant_title && item.variant_title !== 'Default Title' ? `${item.variant_title} · ` : ''}${item.quantity}`;
const price = document.createElement('span');
price.textContent = money(item.final_line_price);
copy.append(title, variant, price);
line.append(imageWrap, copy);
drawerBody.append(line);
});
};
const refreshCart = async () => {
const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
if (!response.ok) throw new Error('Could not refresh cart');
const cart = await response.json();
updateCartUi(cart);
return cart;
};
const productRoot = $('[data-product-root]');
if (productRoot) {
const form = $('#norvale-product-form', productRoot);
const variantScript = $('[data-product-variants]');
let variants = [];
try { variants = JSON.parse(variantScript?.textContent || '[]'); } catch (_) { variants = []; }
const optionSelects = $$(productRoot, '[data-option-index]');
const variantIdInput = $('[data-variant-id]', productRoot);
const quantityInput = $('[data-main-quantity]', productRoot);
const quantityDisplay = $('[data-quantity-display]', productRoot);
const quantityMinus = $('[data-quantity-minus]', productRoot);
const quantityPlus = $('[data-quantity-plus]', productRoot);
const addButton = $('[data-add-to-cart]', productRoot);
const addLabel = $('[data-add-label]', productRoot);
const addTotal = $('[data-add-total]', productRoot);
const message = $('[data-product-message]', productRoot);
const currentPrice = $('[data-current-price]', productRoot);
const comparePrice = $('[data-compare-price]', productRoot);
const bundleRadios = $$ (productRoot, '[data-bundle-qty]');
const addOnInputs = $$ (productRoot, '[data-addon-id]');
const sticky = $('[data-sticky-cart]', productRoot);
const stickyPrice = $('[data-sticky-price]', productRoot);
const stickyVariant = $('[data-sticky-variant]', productRoot);
const stickyButton = $('[data-sticky-add]', productRoot);
const purchasePanel = $('[data-purchase-panel]', productRoot);
let selectedVariant = variants.find((variant) => String(variant.id) === String(variantIdInput?.value)) || variants[0];
let selectedQuantity = 1;
let adding = false;
const renderTotals = () => {
if (!selectedVariant) return;
const base = Number(selectedVariant.price) * selectedQuantity;
const addOnsTotal = addOnInputs.reduce((sum, input) => sum + (input.checked ? Number(input.dataset.addonPrice || 0) : 0), 0);
const total = base + addOnsTotal;
if (addTotal) addTotal.textContent = money(total);
$$ (productRoot, '[data-bundle-price]').forEach((node) => {
node.textContent = money(Number(selectedVariant.price) * Number(node.dataset.qty || 1));
});
if (quantityInput) quantityInput.value = String(selectedQuantity);
};
const setVariant = (variant) => {
selectedVariant = variant;
if (!variant) {
if (addButton) addButton.disabled = true;
if (addLabel) addLabel.textContent = 'UNAVAILABLE';
if (message) message.textContent = 'This combination is unavailable. Please choose another option.';
return;
}
if (variantIdInput) variantIdInput.value = variant.id;
if (currentPrice) currentPrice.textContent = money(variant.price);
if (comparePrice) {
if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
comparePrice.hidden = false;
comparePrice.textContent = money(variant.compare_at_price);
} else {
comparePrice.hidden = true;
comparePrice.textContent = '';
}
}
const available = Boolean(variant.available);
if (addButton) addButton.disabled = !available;
if (stickyButton) stickyButton.disabled = !available;
if (addLabel) addLabel.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
if (message) message.textContent = available ? '' : 'This model is currently sold out.';
if (stickyVariant) stickyVariant.textContent = variant.title === 'Default Title' ? '' : variant.title;
if (stickyPrice) stickyPrice.textContent = money(variant.price);
if (variant.featured_media?.id) {
const matchingSlide = $(`[data-media-id="${variant.featured_media.id}"]`, productRoot);
if (matchingSlide) showGallerySlide($$(productRoot, '[data-gallery-slide]').indexOf(matchingSlide));
}
optionSelects.forEach((select, index) => {
const label = $(`[data-option-selected="${index}"]`, productRoot);
if (label) label.textContent = select.value;
});
renderTotals();
try {
const url = new URL(window.location.href);
url.searchParams.set('variant', variant.id);
window.history.replaceState({}, '', url.toString());
} catch (_) {  }
};
optionSelects.forEach((select) => select.addEventListener('change', () => {
const values = optionSelects.map((item) => item.value);
const variant = variants.find((item) => item.options.every((option, index) => option === values[index]));
setVariant(variant);
}));
bundleRadios.forEach((radio) => radio.addEventListener('change', () => {
if (!radio.checked) return;
selectedQuantity = Math.max(1, Number(radio.value) || 1);
$$(productRoot, '.nv-bundle-choice').forEach((choice) => choice.classList.toggle('is-selected', $('input', choice) === radio));
renderTotals();
}));
addOnInputs.forEach((input) => input.addEventListener('change', renderTotals));
const syncQuantity = (rawValue) => {
const parsed = Number.parseInt(rawValue, 10);
selectedQuantity = Number.isFinite(parsed) ? Math.max(1, Math.min(99, parsed)) : 1;
if (quantityDisplay) quantityDisplay.value = String(selectedQuantity);
renderTotals();
};
quantityMinus?.addEventListener('click', () => syncQuantity(selectedQuantity - 1));
quantityPlus?.addEventListener('click', () => syncQuantity(selectedQuantity + 1));
quantityDisplay?.addEventListener('change', () => syncQuantity(quantityDisplay.value));
quantityDisplay?.addEventListener('input', () => {
if (quantityDisplay.value !== '') {
const parsed = Number.parseInt(quantityDisplay.value, 10);
if (Number.isFinite(parsed) && parsed > 0) syncQuantity(parsed);
}
});
const setButtonLoading = (loading) => {
if (addButton) {
addButton.disabled = loading || !selectedVariant?.available;
if (addLabel) addLabel.textContent = loading ? 'ADDING…' : (selectedVariant?.available ? 'ADD TO CART' : 'SOLD OUT');
}
if (stickyButton) stickyButton.disabled = loading || !selectedVariant?.available;
};
const submitProduct = async () => {
if (adding || !selectedVariant?.available) return;
adding = true;
setButtonLoading(true);
if (message) message.textContent = '';
const items = [{ id: Number(selectedVariant.id), quantity: selectedQuantity }];
addOnInputs.filter((input) => input.checked).forEach((input) => items.push({ id: Number(input.dataset.addonId), quantity: 1 }));
try {
const response = await fetch(`${window.APEXRIDE?.addUrl || '/cart/add'}.js`, {
method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ items })
});
const result = await response.json();
if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this product. Please try again.');
const cart = await refreshCart();
toast('Added to your cart.');
openCart();
document.dispatchEvent(new CustomEvent('norvale:cart-updated', { detail: cart }));
} catch (error) {
if (message) message.textContent = error.message || 'Something went wrong. Please try again.';
toast(error.message || 'Could not add this product.');
} finally {
adding = false;
setButtonLoading(false);
}
};
form?.addEventListener('submit', (event) => { event.preventDefault(); submitProduct(); });
stickyButton?.addEventListener('click', submitProduct);
let activeGalleryIndex = 0;
const slides = $$(productRoot, '[data-gallery-slide]');
const thumbs = $$(productRoot, '[data-gallery-thumb]');
const showGallerySlide = (index) => {
if (!slides.length) return;
activeGalleryIndex = (index + slides.length) % slides.length;
slides.forEach((slide, i) => { slide.hidden = i !== activeGalleryIndex; slide.classList.toggle('is-active', i === activeGalleryIndex); });
thumbs.forEach((thumb, i) => {
thumb.classList.toggle('is-active', i === activeGalleryIndex);
thumb.setAttribute('aria-pressed', String(i === activeGalleryIndex));
});
};
thumbs.forEach((thumb) => thumb.addEventListener('click', () => showGallerySlide(Number(thumb.dataset.index || 0))));
$('[data-gallery-prev]', productRoot)?.addEventListener('click', () => showGallerySlide(activeGalleryIndex - 1));
$('[data-gallery-next]', productRoot)?.addEventListener('click', () => showGallerySlide(activeGalleryIndex + 1));
const galleryStage = $('[data-gallery-stage]', productRoot);
if (galleryStage && !galleryStage.dataset.swipeReady) {
galleryStage.dataset.swipeReady = 'true'; galleryStage.style.touchAction = 'pan-y pinch-zoom';
let touchStartX = 0, touchStartY = 0, trackingSwipe = false;
galleryStage.addEventListener('pointerdown', (event) => { if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return; trackingSwipe = true; touchStartX = event.clientX; touchStartY = event.clientY; }, { passive: true });
galleryStage.addEventListener('pointerup', (event) => { if (!trackingSwipe) return; trackingSwipe = false; const dx = event.clientX - touchStartX, dy = event.clientY - touchStartY; if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.2) return; showGallerySlide(activeGalleryIndex + (dx < 0 ? 1 : -1)); }, { passive: true });
galleryStage.addEventListener('pointercancel', () => { trackingSwipe = false; }, { passive: true });
}
const imageModal = $('[data-image-modal]', productRoot);
const modalImage = $('[data-image-modal-src]', imageModal || productRoot);
$$ (productRoot, '[data-gallery-zoom]').forEach((button) => button.addEventListener('click', () => {
if (!imageModal || !modalImage || !button.dataset.fullImage) return;
modalImage.src = button.dataset.fullImage;
if (typeof imageModal.showModal === 'function') imageModal.showModal();
}));
$('[data-image-close]', imageModal || productRoot)?.addEventListener('click', () => imageModal?.close());
imageModal?.addEventListener('click', (event) => { if (event.target === imageModal) imageModal.close(); });
if (sticky && purchasePanel && 'IntersectionObserver' in window) {
const observer = new IntersectionObserver((entries) => {
const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.08);
sticky.hidden = visible;
}, { threshold: [0, 0.08, 0.25] });
observer.observe(purchasePanel);
}
if (selectedVariant) setVariant(selectedVariant);
}
$$ (document, '[data-scroll-prev]').forEach((button) => button.addEventListener('click', () => {
const track = $(`[data-carousel="${button.dataset.scrollPrev}"]`);
track?.scrollBy({ left: -Math.max(260, track.clientWidth * 0.8), behavior: 'smooth' });
}));
$$ (document, '[data-scroll-next]').forEach((button) => button.addEventListener('click', () => {
const track = $(`[data-carousel="${button.dataset.scrollNext}"]`);
track?.scrollBy({ left: Math.max(260, track.clientWidth * 0.8), behavior: 'smooth' });
}));
$('[data-sort-by]')?.addEventListener('change', (event) => {
const url = new URL(window.location.href);
url.searchParams.set('sort_by', event.target.value);
window.location.assign(url.toString());
});
})();